import { PureComponent } from 'react';
// @ts-expect-error untyped module
import KnowledgeBaseButton from 'ui-addon-i18n/components/KnowledgeBaseButton';
import { SupportLinks } from 'automation-ui-usage-tracking/SupportLinks';
import { trackEvent } from 'automation-ui-usage-tracking/trackingUtils';
import Trackables from 'automation-ui-usage-tracking/Trackables';
import UsageTrackerContext from 'automation-ui-usage-tracking/UsageTrackerContext';
import { jsx as _jsx } from "react/jsx-runtime";
class DocButton extends PureComponent {
  render() {
    const {
      usageTracker
    } = this.context;
    const {
      use,
      supportKey,
      children
    } = this.props;
    if (!supportKey) {
      return null;
    }
    const {
      url,
      useZorse
    } = SupportLinks.has(supportKey) ? SupportLinks.get(supportKey) : {
      url: undefined,
      useZorse: undefined
    };
    if (!url) {
      return null;
    }
    const trackClick = event => {
      event.stopPropagation();
      trackEvent(usageTracker, Trackables.VIEW_DOC, {
        document: url
      });
    };
    if (use === 'link') {
      /*
      className was added to this component because when more than one DocButton
      is rendered in an element, those after the first will have a left margin
      due to the default spacing styles of the UIButton component.
      */
      // @bend-expect trellis-tokenized
      return /*#__PURE__*/_jsx(KnowledgeBaseButton, {
        useZorse: !!useZorse,
        className: 'm-left-0',
        use: use,
        url: url,
        onClick: trackClick,
        children: children
      });
    }
    return /*#__PURE__*/_jsx(KnowledgeBaseButton, {
      useZorse: !!useZorse,
      use: use,
      url: url,
      onClick: trackClick,
      children: children
    });
  }
}
DocButton.defaultProps = {
  use: 'link',
  className: ''
};
DocButton.contextType = UsageTrackerContext;
export default DocButton;